/* Voyanta One trolley builder - behaviour. Config read from data-attributes on [data-vb-root]. */
(function () {
  /* ---------- Tabbed description (independent of the builder) ---------- */
  document.querySelectorAll('[data-vb-tabs]').forEach(function (tabs) {
    var btns = tabs.querySelectorAll('[data-vb-tab]');
    var panels = tabs.querySelectorAll('[data-vb-panel]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-vb-tab');
        btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-vb-panel') === key); });
      });
    });
  });

  var root = document.querySelector('[data-vb-root]');
  if (!root) return;

  var TROLLEY_ID = parseInt(root.getAttribute('data-trolley-id'), 10);
  var KIT_IDS = (root.getAttribute('data-kit-ids') || '').split(',').map(function (s) {
    return parseInt(s, 10);
  }).filter(function (n) { return !isNaN(n); });
  var CART_URL = root.getAttribute('data-cart-url') || '/cart';
  var CART_ADD_URL = root.getAttribute('data-cart-add-url') || '/cart/add';

  var warningEl = root.querySelector('[data-vb-warning]');
  var summaryEl = root.querySelector('[data-vb-summary]');
  var countEl = root.querySelector('[data-vb-count]');
  var totalEl = root.querySelector('[data-vb-total]');
  var toastEl = root.querySelector('[data-vb-toast]');
  var stepTrolley = root.querySelector('[data-vb-step="trolley"]');

  function formatMoney(cents) { return '£' + (cents / 100).toFixed(2); }

  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.header-cart__count').forEach(function (el) { el.textContent = count; });
  }

  /* Add-on dropdowns: update the shown price when a different option is chosen */
  root.querySelectorAll('[data-vb-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var priceEl = sel.closest('.vb-card').querySelector('[data-vb-price]');
      if (priceEl && opt && opt.getAttribute('data-price')) priceEl.textContent = opt.getAttribute('data-price');
    });
  });

  function variantIdsOf(card) {
    return (card.getAttribute('data-vb-card') || '').split(',').map(function (s) {
      return parseInt(s, 10);
    }).filter(function (n) { return !isNaN(n); });
  }

  function render(cart) {
    var idsInCart = (cart.items || []).map(function (i) { return i.variant_id || i.id; });
    var hasTrolley = idsInCart.indexOf(TROLLEY_ID) !== -1;
    var hasKit = idsInCart.some(function (id) { return KIT_IDS.indexOf(id) !== -1; });

    root.querySelectorAll('.vb-card').forEach(function (card) {
      var ids = variantIdsOf(card);
      var inCart = ids.some(function (id) { return idsInCart.indexOf(id) !== -1; });
      card.classList.toggle('is-in-cart', inCart);
      var btn = card.querySelector('[data-vb-add]');
      if (btn && inCart && !card.querySelector('[data-vb-select]')) {
        btn.textContent = 'Add another';
        btn.classList.add('vb-btn--outline');
      }
    });
    // Step 1 hero in-cart state
    if (stepTrolley) {
      var heroInCart = idsInCart.indexOf(TROLLEY_ID) !== -1;
      stepTrolley.classList.toggle('is-in-cart-hero', heroInCart);
      var heroWrap = stepTrolley.querySelector('.vb-hero');
      if (heroWrap) heroWrap.classList.toggle('is-in-cart', heroInCart);
    }

    if (stepTrolley) {
      stepTrolley.classList.toggle('vb-step--done', hasTrolley);
      stepTrolley.classList.toggle('vb-step--active', !hasTrolley);
    }

    if (warningEl) warningEl.classList.toggle('is-visible', hasKit && !hasTrolley);

    if (summaryEl) {
      if (cart.item_count > 0) {
        summaryEl.hidden = false;
        if (countEl) countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      } else {
        summaryEl.hidden = true;
      }
    }
    updateHeaderCount(cart.item_count);
  }

  function getCart() {
    return fetch(CART_URL + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function addToCart(id) {
    return fetch(CART_ADD_URL + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vb-add]');
    if (!btn) return;
    e.preventDefault();
    // Only look for an option <select> when the button is inside its own card.
    // The trolley/warning buttons live outside a card, so they must use their own data-vb-add
    // (otherwise they'd grab the first add-on dropdown on the page).
    var card = btn.closest('.vb-card');
    var sel = card ? card.querySelector('[data-vb-select]') : null;
    var id = sel ? parseInt(sel.value, 10) : parseInt(btn.getAttribute('data-vb-add'), 10);
    if (!id) return;
    // Friendly name for the toast: the card's display name, or the hero (trolley) name.
    var nameEl = card ? card.querySelector('.vb-card__name') : null;
    if (!nameEl) { var heroEl = btn.closest('.vb-hero'); if (heroEl) { nameEl = heroEl.querySelector('.vb-hero__name'); } }
    var displayName = nameEl ? nameEl.textContent.replace(/\s+/g, ' ').trim() : '';
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    addToCart(id).then(function (res) {
      var name = displayName || (res.items && res.items[0] && res.items[0].product_title) || 'Item';
      toast(name + ' added to your basket');
      return getCart();
    }).then(render).catch(function (err) {
      toast((err && err.description) || 'Sorry, that could not be added. Please try again.');
    }).finally(function () {
      btn.disabled = false;
      if (btn.textContent === 'Adding...') btn.textContent = original;
    });
  });

  getCart().then(render).catch(function () {});
})();

/* ---------- Floating "Build your Voyanta One" button + hero CTA smooth-scroll ---------- */
(function () {
  var builder = document.querySelector('.voyanta-builder');
  if (!builder) return;

  function scrollToEl(el) { if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

  /* Hero CTAs (rendered in the product info column) */
  document.querySelectorAll('.vb-hi__cta').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); scrollToEl(builder); });
  });
  document.querySelectorAll('.vb-hi__specs').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); scrollToEl(document.querySelector('.voyanta-tabs')); });
  });

  /* Floating button: appears once the user scrolls past the hero, hides when the builder is in view */
  var fab = document.createElement('button');
  fab.type = 'button';
  fab.className = 'vb-fab';
  fab.setAttribute('aria-label', 'Jump to Build your Voyanta One');
  fab.innerHTML = 'Build your Voyanta One <span class="vb-fab__icon" aria-hidden="true">&#8595;</span>';
  fab.addEventListener('click', function () { scrollToEl(builder); });
  document.body.appendChild(fab);

  function update() {
    var rect = builder.getBoundingClientRect();
    var builderInView = rect.top < window.innerHeight * 0.7 && rect.bottom > 0;
    var scrolledEnough = window.scrollY > 420;
    fab.classList.toggle('is-visible', scrolledEnough && !builderInView);
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
